<template>
  <div class="my-5 text-center">
    <div class="my-5">본인인증에 성공했습니다.</div>
    <mdb-btn @click="onOk" icon="check"> 확인</mdb-btn>
  </div>
</template>
<script>
import { } from 'mdbvue';
export default {
  name: 'JoinAuthSuccess',
  components: {},
  props: [],
  data: () => ({
    TAG: 'JoinAuthSuccess :'
  }),
  computed: {
  },
  methods: {
    onOk () {
      const org = this.$route.params.org
      opener.location = `/${org}/join/profile`
      window.close()
    }
  }
}
</script>
